<template>
  <v-container grid-list-md>
    <v-row>
      <v-col v-for="catalog in catalogs" :key="catalog.id">
        <a @click.prevent="show(catalog.id)">{{ catalog.title }}</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo: { title: 'Catalogs' },
   layout: (h, page) => h(Layout, [page]),
   props: {
      catalogs: {
         type: Array,
         required: true,
      },
   },
   methods: {
      show (_catalog) {
         this.$inertia.visit(this.route('catalog.show', _catalog))
      },
   },
}
</script>

<style>
</style>
